import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
// import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import {  Checkbox, TextField } from '@mui/material';

// import { useEffect } from "react";




function Verify() {

    const { loginStore } = useStore();
    const { UserProfileStore } = useStore();


    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: '350px',
            height: "400px",
        },
        DialogMobile: {
            height: 'auto',
            width: '100%',
            minWidth: "320px",
        },
        //blackWallet
        blackWalletImage: {
            width: '108%',
            marginRight: '-265px'

        },
        blackWalletImageMobile: {
            width: '90%',
            marginRight: '-265px'
        },
    }));




    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const isVerifyDialogOpen = loginStore.isVerifyDialogOpen;
    const VerifyShareBool = UserProfileStore.VerifyShareBool;
    const PhoneNumberButton = UserProfileStore.PhoneNumberButton;

    
    let Guide_clover_allPage_04 = loginStore?.Guide_clover_allPage_04; //개인정보 수집 이용 동의
    let Guide_clover_dialog_Verify_01 = loginStore?.Guide_clover_dialog_Verify_01; //My.인증
    let Guide_clover_dialog_Verify_02 = loginStore?.Guide_clover_dialog_Verify_02; //번호확인
    let Guide_clover_dialog_Verify_03 = loginStore?.Guide_clover_dialog_Verify_03; //인증확인
    let Guide_clover_dialog_Verify_04 = loginStore?.Guide_clover_dialog_Verify_04; //전화번호를 입력해 주세요
    let Guide_clover_dialog_Verify_05 = loginStore?.Guide_clover_dialog_Verify_05; //인증번호를 입력해 주세요










    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize:"1.5rem"
            
        }
    })(Typography);





    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isVerifyDialogOpen} onClose={loginStore.setDialogClose}>
                <Box sx={{ display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600vw', height: '7vh', }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography variant={isMobile ? "subtitle1" : "h5"}>{Guide_clover_dialog_Verify_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("VerifyFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <DialogContent >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction="column" justifyContent='space-between' alignItems='center' >
                        {/* <Button  onClick={(e) => {loginStore.setDialogOpen("SignUp")}}>test</Button> */}
                        <Grid container   direction="row" justifyContent='center' alignItems='center'>
                            <Checkbox checked={VerifyShareBool} onChange={(e) => { UserProfileStore.setPersonalInformationConsentCheck(e.target.checked) }} />
                            <Box onClick={(e) => { loginStore.setDialogOpen("Authentication") }}>{Guide_clover_allPage_04}</Box>
                        </Grid>
                        {/* <FormControlLabel onClick={(e) => {loginStore.setDialogOpen("Authentication")}} label="개인정보 수집 이용 동의" /> */}
                        <TextField
                            variant="standard"
                            label={Guide_clover_dialog_Verify_04}
                            inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                            fullWidth
                            onChange={(e) => { UserProfileStore.setVerifyPhoneNumber(e) }}
                        />
                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                            <Button disabled={PhoneNumberButton} onClick={(e) => { UserProfileStore.setSendVerifyMessage(e) }}>
                                {Guide_clover_dialog_Verify_02}
                            </Button>
                        </Grid>
                        <TextField
                            variant="standard"
                            label={Guide_clover_dialog_Verify_05}
                            inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                            fullWidth
                            onChange={(e) => { UserProfileStore.setVerifyCode(e) }}
                        />
                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                            <Button onClick={(e) => { UserProfileStore.registVerification(e) }}>
                                {Guide_clover_dialog_Verify_03}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
};


export default observer(Verify);